const Parking = require('../../../assets/img/icon-establishment-parking.svg');
const CarWash = require('../../../assets/img/icon-establishment-car-wash.svg');

export const businessTypes = [
  { id: 1, label: 'Estacionamento', icon: Parking },
  { id: 2, label: 'Estética Automotiva', icon: CarWash }
];

export const businessTypesAdmin = [
  ...businessTypes,
  { id: 3, label: 'Loja', icon: 'store' }
];